/**
 * Converts string to number, if string is NaN zero is returned
 */
const convertStringToNumber = (item: string) => {
  const convertedNumber = Number(item);
  return Number.isNaN(convertedNumber) ? 0 : convertedNumber;
}

export {
  convertStringToNumber
}
